import { getPath } from '@/router/common'
const baseUrl = {
  title: '开派车单',
  path: 'OutgoingRegistration'
}

export default [
  {
    path: getPath('DeliveryStockDailyReport', baseUrl),
    name: 'OperationClassReport_DeliveryStockDailyReport',
    component: () => import(/* webpackChunkName: "OperationClassReport_DeliveryStockDailyReport" */ '@/views/operationClassReport/deliveryStockDailyReport/index.vue'),
    meta: {
      title: '库存日报表'
    }
  },
  {
    path: getPath('MiddleOutStock', baseUrl),
    name: 'OutgoingRegistration_MiddleOutStock',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_MiddleOutStock" */ '@/views/outgoingRegistration/middleOutStock/index.vue'),
    meta: {
      title: '转送出库'
    }
  },
  {
    path: getPath('DeliveryRecordDetail', baseUrl),
    name: 'OutgoingRegistration_DeliveryRecordDetail',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_DeliveryRecordDetail" */ '@/views/outgoingRegistration/deliveryRecordDetail/index.vue'),
    meta: {
      title: '出库记录明细'
    }
  },
  {
    path: getPath('HomeAgent', baseUrl),
    name: 'OutgoingRegistration_HomeAgent',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_HomeAgent" */ '@/views/outgoingRegistration/homeAgent/index.vue'),
    meta: {
      title: '本地代理'
    }
  },
  {
    path: getPath('DailyAgentReport', baseUrl),
    name: 'OutgoingRegistration_DailyAgentReport',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_DailyAgentReport" */ '@/views/outgoingRegistration/dailyAgentReport/index.vue'),
    meta: {
      title: '货物中转日报表'
    }
  },
  {
    path: getPath('BatchMiddle', baseUrl),
    name: 'OutgoingRegistration_BatchMiddle',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_BatchMiddle" */ '@/views/outgoingRegistration/batchMiddle/index.vue'),
    meta: {
      title: '终端代理|本地代理-批量中转'
    }
  },
  {
    path: getPath('SingleMiddle', baseUrl),
    name: 'OutgoingRegistration_SingleMiddle',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_SingleMiddle" */ '@/views/outgoingRegistration/singleMiddle/index.vue'),
    meta: {
      title: '终端代理|本地代理-单票中转'
    }
  },
  {
    path: getPath('outMiddleUpload', baseUrl),
    name: 'OutgoingRegistration_outMiddleUpload',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_outMiddleUpload" */ '@/views/outgoingRegistration/outMiddleUpload/index.vue'),
    meta: {
      title: '终端代理|本地代理-批量导入'
    }
  },
  {
    path: getPath('outMiddleUploadADD', baseUrl),
    name: 'outgoingregistration_outMiddleUploadADD',
    component: () => import(/* webpackChunkName: "outgoingregistration_outMiddleUploadADD" */ '@/views/outgoingRegistration/outMiddleUploadADD/index.vue'),
    meta: {
      title: '导入'
    }
  },
  {
    path: getPath('LookOutMiddleUploadDetails', baseUrl),
    name: 'outgoingregistration_LookOutMiddleUploadDetails',
    component: () => import(/* webpackChunkName: "outgoingregistration_LookOutMiddleUploadDetails" */ '@/views/outgoingRegistration/lookOutMiddleUploadDetails/index.vue'),
    meta: {
      title: '中转导入明细'
    }
  },
  {
    path: getPath('outAccUpload', baseUrl),
    name: 'OutgoingRegistration_outAccUpload',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_outAccUpload" */ '@/views/outgoingRegistration/outAccUpload/index.vue'),
    meta: {
      title: '终端代理|本地代理-中转费批量导入'
    }
  },
  {
    path: getPath('outAccUploadADD', baseUrl),
    name: 'outgoingregistration_outAccUploadADD',
    component: () => import(/* webpackChunkName: "outgoingregistration_outAccUploadADD" */ '@/views/outgoingRegistration/outAccUploadADD/index.vue'),
    meta: {
      title: '导入'
    }
  },
  {
    path: getPath('LookOutAccUploadDetails', baseUrl),
    name: 'outgoingregistration_LookOutAccUploadDetails',
    component: () => import(/* webpackChunkName: "outgoingregistration_LookOutAccUploadDetails" */ '@/views/outgoingRegistration/lookOutAccUploadDetails/index.vue'),
    meta: {
      title: '中转费导入明细'
    }
  },
  {
    path: getPath('DeliveryRecord', baseUrl),
    name: 'OutgoingRegistration_DeliveryRecord',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_DeliveryRecord" */ '@/views/outgoingRegistration/deliveryRecord/index.vue'),
    meta: {
      title: '终端代理|本地代理-出库记录'
    }
  },
  {
    path: getPath('CompleteMiddle', baseUrl),
    name: 'OutgoingRegistration_CompleteMiddle',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_CompleteMiddle" */ '@/views/outgoingRegistration/completeMiddle/index.vue'),
    meta: {
      title: '完成中转'
    }
  },
  {
    path: getPath('AgentMasterRecordDetail', baseUrl),
    name: 'OutgoingRegistration_AgentMasterRecordDetail',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_AgentMasterRecordDetail" */ '@/views/outgoingRegistration/agentMasterRecordDetail/index.vue'),
    meta: {
      title: '代理主记录明细'
    }
  },
  {
    path: getPath('AccoutImport', baseUrl),
    name: 'OutgoingRegistration_AccoutImport',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_AccoutImport" */ '@/views/outgoingRegistration/accoutImport/index.vue'),
    meta: {
      title: '中转信息资料导入'
    }
  },
  {

    path: getPath('PollingTable', baseUrl),
    name: 'OutgoingRegistration_PollingTable',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_PollingTable" */ '@/views/outgoingRegistration/pollingTable/index.vue'),
    meta: {
      title: '开派车单'
    }
  },
  {
    path: getPath('WillImport', baseUrl),
    name: 'OutgoingRegistration_WillImport',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_WillImport" */ '@/views/outgoingRegistration/willImport/index.vue'),
    meta: {
      title: '派车单导入'
    }
  },
  {
    path: getPath('WillImportRecord', baseUrl),
    name: 'OutgoingRegistration_WillImportRecord',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_WillImportRecord" */ '@/views/outgoingRegistration/willImportRecord/index.vue'),
    meta: {
      title: '导入派车单'
    }
  },
  {
    path: getPath('WillDetails', baseUrl),
    name: 'OutgoingRegistration_WillDetails',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_WillDetails" */ '@/views/outgoingRegistration/willDetails/index.vue'),
    meta: {
      title: '导入派车单明细'
    }
  },
  {
    path: getPath('BatchAddBillno', baseUrl),
    name: 'OutgoingRegistration_BatchAddBillno',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_BatchAddBillno" */ '@/views/outgoingRegistration/batchAddBillno/index.vue'),
    meta: {
      title: '派车单'
    }
  },
  {
    path: getPath('WebBatchAddBillno93052', baseUrl),
    name: 'OutgoingRegistration_WebBatchAddBillno93052',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_WebBatchAddBillno93052" */ '@/views/outgoingRegistration/WebBatchAddBillno93052/index.vue'),
    meta: {
      title: '网络订单派车单'
    }
  },
  {
    path: getPath('DispatchOrder_78219', baseUrl),
    name: 'OutgoingRegistration_DispatchOrder_78219',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_DispatchOrder_78219" */ '@/views/outgoingRegistration/dispatchOrder_78219/index.vue'),
    meta: {
      title: '派车单【已付款不可编辑】'
    }
  },
  {
    path: getPath('DispatchOrder', baseUrl),
    name: 'OutgoingRegistration_DispatchOrder',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_DispatchOrder" */ '@/views/outgoingRegistration/dispatchOrder/index.vue'),
    meta: {
      title: '派车单【已付款不可编辑】'
    }
  },
  {
    path: getPath('BatchEditOrder', baseUrl),
    name: 'OutgoingRegistration_BatchEditOrder',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_BatchEditOrder" */ '@/views/outgoingRegistration/batchEditOrder/index.vue'),
    meta: {
      title: '批量修改派车单'
    }
  },
  {
    path: getPath('UNIT_BILLNO', baseUrl),
    name: 'OutgoingRegistration_UNIT_BILLNO',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_UNIT_BILLNO" */ '@/views/outgoingRegistration/uNIT_BILLNO/index.vue'),
    meta: {
      title: '设置运单关联'
    }
  },
  {
    path: getPath('BatchAssociationUnit', baseUrl),
    name: 'OutgoingRegistration_BatchAssociationUnit',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_BatchAssociationUnit" */ '@/views/outgoingRegistration/batchAssociationUnit/index.vue'),
    meta: {
      title: '设置运单关联'
    }
  },
  {
    path: getPath('ORDERNO_BILLNO', baseUrl),
    name: 'OutgoingRegistration_ORDERNO_BILLNO',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_ORDERNO_BILLNO" */ '@/views/outgoingRegistration/oRDERNO_BILLNO/index.vue'),
    meta: {
      title: '设置网络订单关联'
    }
  },
  {
    path: getPath('BatchAddSendcar', baseUrl),
    name: 'OutgoingRegistration_BatchAddSendcar',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_BatchAddSendcar" */ '@/views/outgoingRegistration/batchAddSendcar/index.vue'),
    meta: {
      title: '设置网络订单关联'
    }
  },
  {
    path: getPath('AssociatedCarListGetStock', baseUrl),
    name: 'OutgoingRegistration_AssociatedCarListGetStock',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_AssociatedCarListGetStock" */ '@/views/outgoingRegistration/associatedCarListGetStock/index.vue'),
    meta: {
      title: '尚有库存'
    }
  },
  {
    path: getPath('AssociatedCarListDetail', baseUrl),
    name: 'OutgoingRegistration_AssociatedCarListDetail',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_AssociatedCarListDetail" */ '@/views/outgoingRegistration/associatedCarListDetail/index.vue'),
    meta: {
      title: '派车单清单'
    }
  },
  {
    path: getPath('AssociatedCarListInfo', baseUrl),
    name: 'OutgoingRegistration_AssociatedCarListInfo',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_AssociatedCarListInfo" */ '@/views/outgoingRegistration/associatedCarListInfo/index.vue'),
    meta: {
      title: '派车单明细'
    }
  },

  {
    path: getPath('AssociatedCarListGetStock93052', baseUrl),
    name: 'OutgoingRegistration_AssociatedCarListGetStock93052',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_AssociatedCarListGetStock93052" */ '@/views/outgoingRegistration/associatedCarListGetStock93052/index.vue'),
    meta: {
      title: '尚有库存'
    }
  },
  {
    path: getPath('AssociatedCarListDetail93052', baseUrl),
    name: 'OutgoingRegistration_AssociatedCarListDetail93052',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_AssociatedCarListDetail93052" */ '@/views/outgoingRegistration/associatedCarListDetail93052/index.vue'),
    meta: {
      title: '派车单清单'
    }
  },
  {
    path: getPath('AssociatedCarListInfo93052', baseUrl),
    name: 'OutgoingRegistration_AssociatedCarListInfo93052',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_AssociatedCarListInfo93052" */ '@/views/outgoingRegistration/associatedCarListInfo93052/index.vue'),
    meta: {
      title: '派车单明细'
    }
  },
  {
    path: getPath('ContractSettlementInfo', baseUrl),
    name: 'OutgoingRegistration_ContractSettlementInfo',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_ContractSettlementInfo" */ '@/views/outgoingRegistration/contractSettlementInfo/index.vue'),
    meta: {
      title: '合同结算信息'
    }
  },
  {
    path: getPath('AssociatedSendCarListGetStock', baseUrl),
    name: 'OutgoingRegistration_AssociatedSendCarListGetStock',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_AssociatedSendCarListGetStock" */ '@/views/outgoingRegistration/associatedSendCarListGetStock/index.vue'),
    meta: {
      title: '尚有库存'
    }
  },
  {
    path: getPath('AssociatedSendCarListDetail', baseUrl),
    name: 'OutgoingRegistration_AssociatedSendCarListDetail',
    component: () => import(/* webpackChunkName: "OutgoingRegistration_AssociatedSendCarListDetail" */ '@/views/outgoingRegistration/associatedSendCarListDetail/index.vue'),
    meta: {
      title: '派车单清单'
    }
  },
]
